import {TweenMax, Power2} from 'gsap';

export class Elevator {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;

  public static init() {

    Elevator.$element = $('.Blog-elevator');
    Elevator.element = Elevator.$element.get(0);

    if (Elevator.$element.length) {
      Elevator.events();
    }
  }


  public static events() {

    let ElevatorTimeout = setTimeout(function () {}, 0);

    $(window).on('load scroll', function () {

      clearTimeout(ElevatorTimeout);

      ElevatorTimeout = setTimeout(function () {
        Elevator.animate();
      }, 250);

    });
  }


  public static lastPositionMax = 0;

  public static animate() {
    let scrollPosistion = $(window).scrollTop();
    let scrollTrigger = scrollPosistion + $(window).height() / 2;
    let elevatorBlockHeight = scrollTrigger - Elevator.element.offsetTop - ($(window).width() * 0.4);

    let seaCorrectif = 0;
    if($('.Landing-page-sea').length) {
      seaCorrectif = $(window).width() * 0.3;
    }

    elevatorBlockHeight = elevatorBlockHeight + seaCorrectif;


    if(elevatorBlockHeight > Elevator.lastPositionMax) {

      Elevator.lastPositionMax = elevatorBlockHeight;

      TweenMax.to(Elevator.$element.find('.Blog-elevator-block'), 0.5, {
        height: elevatorBlockHeight,
        ease: Power2.easeOut
      });

    }

  }


}